<ng-container *transloco="let _t">

<form>
	<h2>{{ _t('building-form-h2-0') }}</h2>
	<div class="row formulaire">
		<div class="col-5">
			<!-- photo -->
			<cmat-picture class="editor-mainphoto"
				[src]="editModel.photo" 
				[alt]="'Photo de l\'établissement'" 
				[uploadable]="true" 
				(changeTriggered)="editModel.photo=$event"
			></cmat-picture>
			<!-- formulaire -->
			<br/>
			<h5>{{ _t('building-form-h5-0') }}</h5>
			<dl class="infos-fields">

				<dt><label for="name">{{ _t('building-form-label-0') }}</label></dt>
				<dd><mat-form-field>
					<input matInput type="text" name="name" [(ngModel)]="editModel.name" />
				</mat-form-field></dd>

				<dt><label for="buildingType">{{ _t('building-form-label-1') }}</label></dt>
				<dd><mat-form-field>
					<mat-select name="buildingType" 
						color="primary"
						[ngStyle]="{'background-color': (valid ? '#393434' : '#b21919')}" 
						[(ngModel)]="editModelBTid">
						<mat-option *ngFor="let bt of gd.buildingTypes" 
									[value]="bt.id">
							{{bt.name}}
						</mat-option>
					</mat-select>
				</mat-form-field></dd>

				<dt><label for="adress1">{{ _t('building-form-label-2') }}</label></dt>
				<dd><mat-form-field>
					<input matInput type="text" name="adress1" [(ngModel)]="editModel.adress1" />
				</mat-form-field></dd>

				<dt><label for="adress2">{{ _t('building-form-label-3') }}</label></dt>
				<dd><mat-form-field>
					<input matInput type="text" name="adress2" [(ngModel)]="editModel.adress2" />
				</mat-form-field></dd>

				<dt><label for="zipcode">{{ _t('building-form-label-4') }}</label></dt>
				<dd><mat-form-field>
					<input matInput type="text" name="zipcode" [(ngModel)]="editModel.zipcode" />
				</mat-form-field></dd>

				<dt><label for="town">{{ _t('building-form-label-5') }}</label></dt>
				<dd><mat-form-field>
					<input matInput type="text" name="town" [(ngModel)]="editModel.town" />
				</mat-form-field></dd>

				<dt><label for="town">{{ _t('building-form-label-6') }}</label></dt>
				<dd><mat-form-field>
					<input matInput type="text" name="region" [(ngModel)]="editModel.region" />
				</mat-form-field></dd>

				<dt><label for="town">{{ _t('building-form-label-7') }}</label></dt>
				<dd><mat-form-field>
					<input matInput type="text" name="country" [(ngModel)]="editModel.country" />
				</mat-form-field></dd>

				<dt><label for="phone">{{ _t('building-form-label-8') }}</label></dt>
				<dd><mat-form-field>
					<input matInput type="text" name="phone" [(ngModel)]="editModel.phone" />
				</mat-form-field></dd>

				<dt><label for="email">{{ _t('building-form-label-9') }}</label></dt>
				<dd><mat-form-field>
					<input matInput type="text" name="email" [(ngModel)]="editModel.email" />
				</mat-form-field></dd>

				<dt><label for="director">{{ _t('building-form-label-10') }}</label></dt>
				<dd><mat-form-field>
					<input matInput type="text" name="director" [(ngModel)]="editModel.director" />
				</mat-form-field></dd>

			</dl>
		</div>
		<div class="col-7 complement">
			<div class="row">
				<!-- Carte de l'établissement -->
				<div class="col-6 pictEdit">
					<cmat-picture 
						[src]="editModel.map" 
						[alt]="'Carte / plan'" 
						[uploadable]="true" 
						(changeTriggered)="editModel.map=$event"
					></cmat-picture>
				</div>
				<!-- organigramme -->
				<div class="col-6 pictEdit">
					<cmat-picture 
						[src]="editModel.organigram" 
						[alt]="'Organigramme'" 
						[uploadable]="true" 
						(changeTriggered)="editModel.organigram=$event"
					></cmat-picture>
				</div>
			</div>
			<!-- notes -->
			<mat-form-field class="mat-form-field-notes">
				<h5 for="notes">{{ _t('building-form-h5-1') }}</h5>
				<textarea matInput color="primary" name="notes" [(ngModel)]="editModel.notes"></textarea>
			</mat-form-field>
		</div>
	</div>
</form>


</ng-container>